import chatScript from "../ChatScript.json"

import { format } from "date-fns"

const BOT_SENDER = "bot"

function addMetaInfo(message) {
    message.sender = BOT_SENDER
    message.time = format(new Date(), "HH:mm")
}

function getFirstMessage() {
    return getMessageById("1")
}

function getMessageById(id) {
   // debugger;
    const msg = chatScript.frasi.find(x => x.id === id)


    msg && addMetaInfo(msg)

    //  current = msg

    return msg
}

export default  {addMetaInfo, getFirstMessage,getMessageById} 